import { render, staticRenderFns } from "./ProductFour.vue?vue&type=template&id=4f0d5752&"
import script from "./ProductFour.vue?vue&type=script&lang=js&"
export * from "./ProductFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0d5752')) {
      api.createRecord('4f0d5752', component.options)
    } else {
      api.reload('4f0d5752', component.options)
    }
    module.hot.accept("./ProductFour.vue?vue&type=template&id=4f0d5752&", function () {
      api.rerender('4f0d5752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductFour.vue"
export default component.exports